import React from "react";

export default function TenMinsYC() {
  return (
    <div className="p-2.5 gap-2.5 bg-Onyx inline-flex flex-col items-center justify-start w-full pb-10">
      <div className="max-w-6xl">
        <p className="font-Inter font-bold text-white inline text-[40px] leading-[normal]">
          10 Mins in Y Combinator
        </p>
        <div className="w-[166px] h-[0] outline outline-1 outline-[rgba(242,242,242,1)]"></div>
        <p className="font-Inter text-sm font-extralight text-Grey inline leading-[normal]">
          Written on 16/06/22
        </p>
        <div className="w-full inline-flex flex-col items-center justify-center">
          <div className="bg-center bg-no-repeat bg-contain w-full h-[387px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/6eda50c22b2ce7e84ca2a93ccaf19652aeef46b6.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline leading-[normal]">
            The email where it all started
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            So the first time we applied to YC was late 2021. At that time we
            had nothing more than an idea for an app completely different from
            what we are developing today. But we were doing the right things
            (that I believe any founder should be doing) - talking to users,
            building our product, and wasting minimal time doing any other
            nonsense and crap. An advisor at the time recommended that we apply
            YC. We hardly expected to get in, but we applied anyway.
            <br />
            <br />
            We got rejected, but what we did receive was an email informing us
            that we were in the top 10% of applicants and that we should apply
            again the next round.
            <br />
            <br />
            Fast forward 3 months, we had pivoted our product, had several email
            signups for FireJet. We had also accidentally launched FireJet
            already (It was live on the Figma store and we didn’t realise it)
            and it had downloads with zero advertising done whatsoever.
            <br />
            <br />
            So naturally we filled in the application form, (which by the way
            helps you keep on track about the metrics that matter for your
            startup) about how we
            <br />
            <br />
            Went from zero to MVP in a week
            <br />
            Had 200 initial signups
            <br />
            Had 20 downloads
            <br />
            Had one customer who signed an LOI indicating his willingness to pay
            <br />
            <br />
            and how we achieved all these in less than a month.&nbsp;
            <br />
            <br />
            Even so, we didn’t really expect a reply from YC considering how
            difficult it is to get in. So you can imagine our surprise when we
            received this email:
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-start">
          <div className="bg-center bg-no-repeat bg-contain w-full h-[481px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/3090cde589fa22df3da9bff35c930ab2c045f7ba.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline drop-shadow-lg leading-[normal]">
            YC invitation to interview
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            To be honest, at this point it felt like we were already accepted
            into YC (Spoiler: we weren’t). And it put us in a good mood, until
            we realised that we had to start preparing for the interview.
            <br />
            <br />
            In fact, several of my friends had also been invited for the YC
            interview, namely from Dashibase and Scratchbac.
            <br />
            <br />
            We did some research on how to prepare for the YC interview, and it
            seemed like the best way to approach is was to just go in with
            whatever facts you have about the business.
            <br />
            <br />
            Our plan was to answer questions based on actions that we had taken
            instead of theory. For example, if they asked us how are we growing
            we could immediately reply our downloads were increasing at a rate
            of 15% weekly consistently for the past 4 weeks.
            <br />
            <br />
            We heard that the interview questions would be rapid fire and that
            interviewers may interrupt you sometimes, because the interview is
            only 10 minutes long and they need to be able to understand your
            business by the end of the 10 minutes.
            <br />
            <br />
            The general structure of the YC interview is like this:
            <br />
            <br />
            What are you working on?
            <br />
            What have you done so far?
            <br />
            Specific questions related to your business
            <br />
            <br />
            So after some preparation it was finally time for the interview. It
            was at something like 3am for us, but we were extremely pumped with
            adrenaline for the whole day before then.
            <br />
            <br />
            In the end, we waited roughly 30 minutes past our time slot before
            the zoom meeting opening. Our interviewers with Gustaf Alströmer,
            Stephanie Simon and Puneet Kumar, so it was pretty exciting to get
            to meet some really famous, successful entreprenuers.
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-start">
          <div className="bg-center bg-no-repeat bg-contain w-full h-[202px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/643aada3b84d44b913ee293baa590492102e886c.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline drop-shadow-lg leading-[normal]">
            Gustaf Alstromer also happened to give this cool talk
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            Actually, Gustaf Alstromer gave an open talk about ‘how to get users
            and grow’, and his talk is one of the reasons why I developed an
            analytics dashboard for FireJet to be able to see if users really
            loved FireJet or if they just downloaded it out of curiosity and
            disappeared.
            <br />
            <br />
            And in his talk, he showed some examples of bad retention rates
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-start">
          <div className="bg-center bg-contain bg-no-repeat w-full h-[356px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/ac8e9f86f3b21c4a6c29e71688e885258a7e83b1.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline drop-shadow-lg leading-[normal]">
            Bad Retention
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            And good retention rates
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-start">
          <div className="bg-center bg-contain bg-no-repeat w-full h-[354px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/c5e33e03151c0cf1f51024ceadb14bb7f7326c54.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline drop-shadow-lg leading-[normal]">
            Good Retention
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            So during our interview one of the things we did was show a demo of
            FireJet, and the other thing was we showed them our analytics
            dashboard, (mostly because we wanted to show them that we were data
            driven individuals, not pluck ideas from the sky people)
            <br />
            <br />
            And well, here was our retention at the time:
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-start">
          <div className="bg-center bg-contain bg-no-repeat w-full h-[142px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/e914dfb68e0cb7bc4685505dd08b1dd3d39fc8a1.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline drop-shadow-lg leading-[normal]">
            Incredibly bad retention
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            Notice how it drops close to 0 after the 1st week? Yea anyway we
            didn’t get into YC lmao
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-start">
          <div className="w-full bg-center bg-no-repeat bg-contain h-[324px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/2425d31f3fd736fbca55fcab81c8cd04d9de7a41.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline drop-shadow-lg leading-[normal]">
            Rejection Email
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            In the rejection email, Stephanie told us that several have tried
            this idea before and failed before us. Which is unsurprising,
            because we were actually willing to use competitor products for our
            own internal projects before, but the problem is none of them
            actually worked. In the last followup email, we were told that we
            could show that we would succeed by reducing our churn rate (AKA
            increase retention)
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-center">
          <div className="bg-center bg-contain bg-no-repeat w-full h-[221px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4899/d6cd33992c6ce4ebdfffcc58315ccba1d7ae7ef5.webp)]"></div>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            Anyway, I don’t think its that hard to get into YC. Just build a
            great product, talk to your users, show that they are not just fake
            download users but actual recurring users and bish bash bosh you
            will probably get into YC. Anyway I have a headache and would like
            to take a nap, which is why this article is going to come to an
            abrupt end right about now.&nbsp;
          </p>
        </div>
      </div>
    </div>
  );
}
